import axios from "axios";

// Relative /api URLs use the page's host, including when opened from a phone.
export default axios.create({ withCredentials: true });
